export default __webpack_public_path__ + "static/image9-639792131f2eaf81e1721577fae5ef0e.jpg";